import { BaseIcon } from './chunk-MLKFOR3D.js';
import { forwardRef } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var WalletCoinbase = forwardRef(({ variant = "branded", fallback, ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { fallback, ...props, ref, children: variant === "branded" && /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx("path", { fill: "#0E5BFF", d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0" }),
  /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M12 18.375a6.375 6.375 0 1 0 0-12.75 6.375 6.375 0 0 0 0 12.75m-.75-8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125h1.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125z", fillRule: "evenodd", clipRule: "evenodd" })
] }) || variant === "background" && /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#coinbase__a)", children: [
    /* @__PURE__ */ jsx("path", { fill: "#0E5BFF", d: "M24 0H0v24h24z" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0" }),
    /* @__PURE__ */ jsx("path", { fill: "#0E5BFF", d: "M12 17.667a5.667 5.667 0 1 0 0-11.334 5.667 5.667 0 0 0 0 11.334m-.667-7.334a1 1 0 0 0-1 1v1.334a1 1 0 0 0 1 1h1.334a1 1 0 0 0 1-1v-1.334a1 1 0 0 0-1-1z", fillRule: "evenodd", clipRule: "evenodd" })
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "coinbase__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
] }) }));
WalletCoinbase.displayName = "WalletCoinbase";
var WalletCoinbase_default = WalletCoinbase;

export { WalletCoinbase_default };
